import { ReactNode, useState, ReactElement } from 'react';
import { ChevronDownIcon } from '@navikt/aksel-icons';
import classes from './Accordion.module.css';

type AccordionProps = {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
};

export const Accordion = ({
  title,
  children,
  defaultExpanded = false,
}: AccordionProps): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={classes.accordion}>
      <button
        type="button"
        className={classes.trigger}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <span className={classes.title}>{title}</span>
        <ChevronDownIcon
          className={`${classes.icon} ${isExpanded ? classes.iconExpanded : ''}`}
          aria-hidden="true"
        />
      </button>
      {isExpanded && (
        <div className={classes.content}>
          {children}
        </div>
      )}
    </div>
  );
};
